import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ValidateSMTP from "../../../components/FunctionDetails/UserManagements/ValidateSMTP";
import ValidateName from "../../../components/FunctionDetails/UserManagements/ValidateName";
import ValidateActivityName from "../../../components/FunctionDetails/ValidateActivityName";
import AdobeTargetActivitiesRevisions from "../../../components/FunctionDetails/AdobeTargetActivitiesRevisions";
import CreateAtAudienceFromTealium from "../../../components/FunctionDetails/CreateAtAudienceFromTealium";
import backwardArrow from '../../../assets/icons/backward-arrow.svg';
import { useContentfulContext } from "../../../contexts/ContentfulContext";
import GithubExperienceSynchronization from "../../../components/FunctionDetails/GithubExperienceSynchronization";
import TealiumDataLayerRepository from "../../../components/FunctionDetails/TealiumDataLayerRepository";
import ProductFeeds from "../../../components/FunctionDetails/ProductFeeds/ProductFeeds";


const EditSavedTask = () => {
    const { id } = useParams();
    const navigate = useNavigate()
    const { content } = useContentfulContext();
    const [showBackNavigationArrow, setShowBackNavigationArrow] = useState(true);

    const productFeedsTaskId = content?.tasks?.product_feeds?.id || 'product_feeds';

    return (
        <div className="w-full px-4 md:px-8 my-6">
            {showBackNavigationArrow && <div class="w-full pb-2">
                <a href="#" class="font-medium text-primary hover:underline flex items-center" onClick={(e) => {
                    e.preventDefault();
                        navigate("/functions/saved-tasks")
                }}>
                    <img src={backwardArrow} alt='' className='w-5 h-5 mr-2' /> {content.tasks.back_cta_text2}
                </a>
            </div>}
            <main id="main" className="flex flex-col space-y-3 items-start flex-grow">
                {id === content.tasks.smtp.id && <ValidateSMTP />}
                {id === content.tasks.validate_name.id && <ValidateName />}
                {id === content.tasks.validate_activity_name.id && <ValidateActivityName />}
                {id === content.tasks.manage_activity_revisions.id && <AdobeTargetActivitiesRevisions />}
                {id === content.tasks.map_as_audience_to_at_audience.id && <CreateAtAudienceFromTealium />}
                {id === content.tasks.github_experience_sync.id && <GithubExperienceSynchronization />}
                {id === content.tasks.tealium_data_layer_repository.id && <TealiumDataLayerRepository />}
                {id === productFeedsTaskId && <ProductFeeds setShowBackNavigationArrow={setShowBackNavigationArrow} />}
            </main>
        </div>
    );
};

export default EditSavedTask;
